// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.specialoffers.RentalManagerUserPropertySpecialOfferWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  MultiErrorsResponseDto,
  RentalManagerSpecialOfferInputsDto,
  UserPropertyDetailsSpecialOfferDto,
} from '../..';

interface DeleteParams {
  listingAlias: ListingAlias;
  offerIdEncoded: string;
}

export const RentalManagerUserPropertySpecialOfferWebApiHandler_create_Path =
  '/api/web/v1/users/properties/specialOffers/create';

/**
 * Create a special offer for a property
 */
export const RentalManagerUserPropertySpecialOfferWebApiHandler_create = (
  postData: RentalManagerSpecialOfferInputsDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    RentalManagerSpecialOfferInputsDto,
    MultiErrorsResponseDto<UserPropertyDetailsSpecialOfferDto>
  >(
    {
      endpoint: RentalManagerUserPropertySpecialOfferWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpecialOfferWebApiHandler_delete_Path =
  '/api/web/v1/users/properties/specialOffers/delete';

/**
 * Delete a listing special offer
 */
export const RentalManagerUserPropertySpecialOfferWebApiHandler_delete = (
  getParams: DeleteParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DeleteParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySpecialOfferWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySpecialOfferWebApiHandler_update_Path =
  '/api/web/v1/users/properties/specialOffers/update';

/**
 * Update a special offer of a property
 */
export const RentalManagerUserPropertySpecialOfferWebApiHandler_update = (
  postData: RentalManagerSpecialOfferInputsDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    RentalManagerSpecialOfferInputsDto,
    MultiErrorsResponseDto<UserPropertyDetailsSpecialOfferDto>
  >(
    {
      endpoint: RentalManagerUserPropertySpecialOfferWebApiHandler_update_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
